import React, { useMemo } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { CaretRight } from '@phosphor-icons/react';
import { buildBreadcrumbs } from '../../navigation/routeRegistry';

export default function AppBreadcrumbs({ extra = {} }) {
  const location = useLocation();
  const params = useParams();
  const crumbs = useMemo(
    () =>
      buildBreadcrumbs(location.pathname, {
        ticketNo: params.ticketNo || extra.ticketNo,
        clientName: extra.clientName,
        toolName: extra.toolName,
      }),
    [location.pathname, params.ticketNo, extra.ticketNo, extra.clientName, extra.toolName],
  );

  if (!crumbs.length) return null;

  return (
    <nav className="wd-breadcrumbs" aria-label="Breadcrumb">
      <ol className="wd-breadcrumbs-list">
        {crumbs.map((crumb, i) => {
          const isLast = i === crumbs.length - 1;
          return (
            <li key={`${crumb.label}-${i}`} className="wd-breadcrumbs-item">
              {i > 0 ? (
                <CaretRight size={12} className="wd-breadcrumbs-sep" weight="bold" aria-hidden="true" />
              ) : null}
              {isLast || !crumb.to ? (
                <span className="wd-breadcrumbs-current" aria-current={isLast ? 'page' : undefined}>
                  {crumb.label}
                </span>
              ) : (
                <Link to={crumb.to} className="wd-breadcrumbs-link">
                  {crumb.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
